import { render } from "./EmployeeBankDetails.vue?vue&type=template&id=62489360"
import script from "./EmployeeBankDetails.vue?vue&type=script&lang=js"
export * from "./EmployeeBankDetails.vue?vue&type=script&lang=js"

import exportComponent from "/Users/balbeer.yadav/Development/lmthrm/src/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__